// TODO IMPORT TYPES i18n
// import { Composer } from 'vue-i18n';

export interface UseErrorTranslation {
  translateError: (error: Error | null, i18nPath?: string) => string;
}

export function translateError({ t }, error: Error): string {
  const errorMessage = error.message;
  if (errorMessage?.includes('network error')) {
    return t('Login.error.networkError').toString();
  }

  return t('errors.default').toString();
}
